import { Link } from '@tanstack/react-router'
import { CarFront, ArrowLeft, Home } from 'lucide-react'
import { Button } from './ui/button'

export function NotFound() {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 flex flex-col items-center justify-center p-6 text-center">
      <div className="relative mb-6">
        <div className="w-24 h-24 rounded-full bg-blue-600/10 border border-blue-500/20 flex items-center justify-center text-blue-400 shadow-xl shadow-blue-500/5">
          <CarFront size={48} className="animate-pulse" />
        </div>
        <div className="absolute -bottom-2 -right-2 bg-red-500/20 text-red-400 border border-red-500/30 text-xs font-bold px-2 py-0.5 rounded-full">
          404
        </div>
      </div>

      <h1 className="text-4xl font-extrabold tracking-tight bg-gradient-to-r from-white via-slate-200 to-slate-400 bg-clip-text text-transparent mb-3">
        Página Não Encontrada
      </h1>
      
      <p className="text-slate-400 max-w-md mb-8 leading-relaxed text-sm md:text-base">
        O caminho que você tentou acessar não existe, foi movido ou está temporariamente indisponível.
      </p>

      <div className="flex flex-col sm:flex-row items-center gap-3">
        <Button
          asChild
          variant="outline"
          className="border-slate-800 bg-slate-900/60 hover:bg-slate-800 text-slate-200"
        >
          <Link to="/" className="flex items-center gap-2">
            <Home size={16} />
            Início
          </Link>
        </Button>
        <Button
          asChild
          className="bg-blue-600 hover:bg-blue-500 text-white shadow-lg shadow-blue-600/20"
        >
          <Link to="/app" className="flex items-center gap-2">
            <ArrowLeft size={16} />
            Ir para o Pátio / Sistema
          </Link>
        </Button>
      </div>
    </div>
  )
}
